<template>
    <div>
        <van-nav-bar title="专业库" left-text="返回" left-arrow @click-left="onClickLeft" />
        <div class="head">
            <div class="input">
                <div class="select-province">专业搜索</div>
                <input type="text" placeholder="请输入专业名称" v-model="val" class="header-search" />
                <div class="search" @click="search">
                    <Icon type="ios-search-outline" />
                </div>
            </div>
        </div>
        <div class="menu">
            <div
                :class="currentId === item.id?'menu-item':''"
                v-for="item in menu"
                :key="item.id"
                @click="selectMenu(item)"
            >{{item.name}}</div>
        </div>
        <div class="content">
            <div class="left-menu">
                <div
                    :class="currentPid === item.id?'left-item-on':'left-item'"
                    v-for="(item,index) in leftList"
                    :key="index"
                    @click="selectProfessional(item,index)"
                >{{item.name}}</div>
            </div>
            <div class="right-content">
                <div
                    class="right-item"
                    v-for="(i,index) in rightList"
                    :key="index"
                    @click="selectProfessionalItem(i,index)"
                >
                   {{i.name}}
                    <span class="arrow">
                        <van-icon name="arrow-down" />
                    </span>
                    <div
                        v-for="(item,index) in detailList"
                        :key="index"
                        @click="gozyDetail(item.id)"
                        class="right-box"
                    >
                        <span v-if="i.isOpen">{{item.name}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { httpPost } from "../../../axios/index";

export default {
    data() {
        return {
            currentId: 1,
            currentPid: -1,
            menu: [
                { id: 1, name: "本科专业", type: 1 },
                { id: 2, name: "专科专业", type: 0 }
            ],
            leftList: [], //本科专业
            rightList: [], //专科专业
            detailList: [], //详细
            val: ""
        };
    },
    created() {},
    methods: {
        // 点击搜索
        search() {
            this.fetchList(this.val);
        },
        // 点击进入详情
        gozyDetail(e) {
            this.$router.push({
                path: "/professionalDetail",
                query: {
                    id: e
                }
            });
        },
        //返回
        onClickLeft() {
            this.$router.go(-1);
        },

        selectMenu(item) {
            this.currentId = item.id;
            httpPost("/Career/index", {
                type: item.type,
                name: this.val
            }).then(res => {
               
                if (res.code === 1) {
                    this.leftList = res.data;
                    this.rightList = [];
                }
            });
        },
        selectProfessional(item, index) {
            this.currentPid = item.id;
            item.child[0].isOpen = false;
            this.rightList = item.child;
           
        },
        selectProfessionalItem(i, index) {
    
            i.isOpen = !i.isOpen;
            this.detailList = i.child;
        },
        fetchList(name) {
            httpPost("/Career/index", {
                type: 1,
                name: name
            }).then(res => {
              
                if (res.code === 1) {
                    this.leftList = res.data;
                    this.rightList = res.data[0].child;
                }
            });
        }
    },
    mounted() {
        this.fetchList();
    }
};
</script>

<style scoped>
input{
  line-height:normal
}
input::-webkit-input-placeholder,
.inputHead {
    color: #fff;
    font-size: 14px;
    line-height: 2.25rem;
}
.head {
    padding: 1rem 0;
    display: flex;
    background: #22d9d9;
    color: #fff;
    line-height: 0rem;
    font-size: 1rem;
}

.input {
    width: 90vw;
    position: relative;
    border: 0.08rem #fff solid;
    border-radius: 2rem;
    display: flex;
    margin: 0 auto;
}

.select-province {
    font-size: 0.8rem;
    padding: 1.1rem 0.3rem;
    border-right: 0.08rem #fff solid;
}

.search {
    position: absolute;
    top: 0.4rem;
    bottom: 0;
    right: 0.7rem;
    font-size: 1.6rem;
}

.input input {
    border: none;
    background: #22d9d9;
    width: 73%;
    padding: 0.2rem;
    color: #fff;
}
.menu {
    display: flex;
    background: #f2f2f2;
    line-height: 3rem;
    justify-content: space-around;
}
.menu-item {
    color: #22d9d9;
}
.content {
    display: flex;
}
.left-menu {
    width: 30vw;
    text-align: center;
    font-size: 0.9rem;
    background: #f8f8f8;
    height: 76vh;
    overflow-y: scroll;
    overflow-x: hidden;
    padding-bottom: 3rem;
}
.right-content {
    width: 70vw;
    text-align: center;
    font-size: 0.9rem;
    height: 74vh;
    overflow-y: scroll;
    overflow-x: hidden;
    padding-bottom: 3rem;
}
.left-item,
.left-item-on {
    padding: 1rem 0;
    border-bottom: 1px solid #cccccc;
}
.left-item-on {
    background: #fff;
    color: #22d9d9;
}
.right-item {
    padding: 0.5rem 0;
    position: relative;
    background: #f2f2f2;
}
.arrow {
    position: absolute;
    right: 1rem;
}
.right-box {
    line-height: 2.5rem;
}
</style>